import React from 'react'
import SAPIntro from './SAPIntro'
import SAPConsultants from './SAPConsultants'
import SAPWhyChooseUs from './SAPWhyChooseUs'
import SAPStaffAugmentation from './SAPStaffAug'

import SAPOurServoceBenifits from './SAPBenifits'
import ContactForm from './SAPContact'
import SAPAMS from './SAPAMS'
import { useRef } from 'react'
import { Helmet } from 'react-helmet';

const SAP = () => {

    const contact=useRef(null)
  return (
    <div>
      <Helmet>
        <title>PT KCS | SAP ERP Services – Strategy, Implementation & Support Indonesia</title>
        <meta 
          name="description" 
          content="PT KCS offers comprehensive SAP ERP services in Indonesia. From consulting and solution design to full implementation, integration, and staff augmentation." 
        />
        <meta 
          name="keywords" 
          content="PT KCS, PT KCS Tech Indonesia, SAP ERP Jakarta, SAP implementation services, SAP consulting Indonesia, SAP integration and customization, SAP AMS support, enterprise resource planning SAP, digital transformation IT solutions, SAP staff augmentation Indonesia" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

      
                  <section>
              <SAPIntro contact={ contact} />
          </section>


          <section>
              <SAPStaffAugmentation />
          </section>

          
          <section>
              <SAPConsultants/>
          </section>

          
          <section>
              <SAPAMS/>
          </section>

          
         
          



          <section>
              <SAPWhyChooseUs contact={ contact}/>
          </section>
           
          <section>
              <SAPOurServoceBenifits/>
          </section>
          

         
          <section>
              <ContactForm ref={contact} />
          </section>

{/* <div class="hs-form-frame" data-region="na2" data-form-id="37611edb-5b9d-4515-9003-cab18f280e08" data-portal-id="242790435"></div> */}
    </div>
  )
}

export default SAP
